import React, { useEffect, useState } from 'react';
import useNoundlesTheoryTokenDetails from '../hooks/useNoundlesTheoryTokenDetails';
import CompanionThumbnail from './CompanionThumbnail';
import EvilNoundleThumbnail from './EvilNoundleThumbnail';

const TheoryThumbnail = ({ tokenId, size }) => {
  const tokenDetails = useNoundlesTheoryTokenDetails();

  const [type, setType] = useState(0);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const token = tokenDetails[tokenId];
    if (token) {
      setType(token.type);
      setOffset(token.offset);
    }
  }, [tokenId, tokenDetails]);

  return type === 0 ? (
    <CompanionThumbnail tokenId={offset} size={size} />
  ) : (
    <EvilNoundleThumbnail tokenId={offset} size={size} />
  );
};

TheoryThumbnail.defaultProps = {
  size: 200,
};

export default TheoryThumbnail;
